const redirectLocation = process.env.REACT_APP_GHL_REDIRECT_LOCATION ?? "https://app.directorystagingsite.com/integrations/auth/location";
const redirectAccount = process.env.REACT_APP_GHL_REDIRECT_ACCOUNT ?? "https://app.directorystagingsite.com/integrations/agency";
const redirectAgency = process.env.REACT_APP_GHL_REDIRECT_AGENCY || redirectAccount;
const accountLevelUrl = process.env.REACT_APP_ACCOUNT_LEVEL_URL ?? "http://localhost:3004";
const leadSourceLaunchUrl =
  process.env.REACT_APP_LEADSOURCE_LAUNCH_URL ?? "https://sdai-dev.theleadsource.com/launch";
// Fallback when no location override and no email DB row:
// aca4e89324 = starter, bde4789352 = plus, cacbd12238 = pro
const leadSourcePlanId = process.env.REACT_APP_LEADSOURCE_PLAN_ID ?? "aca4e89324";

const env = {
  API_URL: process.env.REACT_APP_API_URL ?? "http://localhost:8082/api",
  SERVER_IP: process.env.REACT_APP_SERVER_IP ?? "104.236.53.124",
  ACCOUNT_LEVEL_URL: accountLevelUrl,
  LEADSOURCE_LAUNCH_URL: leadSourceLaunchUrl,
  LEADSOURCE_PLAN_ID: leadSourcePlanId,
  SSO_key: process.env.REACT_APP_SSO_KEY ?? "",
  Agency_SSO_key: process.env.REACT_APP_AGENCY_SSO_KEY ?? "",
  GHL: {
    CLIENT_ID: process.env.REACT_APP_GHL_CLIENT_ID ?? "",
    CLIENT_SECRET: process.env.REACT_APP_GHL_CLIENT_SECRET ?? "",
    SCOPE: process.env.REACT_APP_GHL_SCOPE ?? "",
    APPSCOPE: process.env.REACT_APP_GHL_SCOPE ?? "",
    LOCATION_CLIENT_ID: process.env.REACT_APP_GHL_LOCATION_CLIENT_ID ?? "",
    Location_CLIENT_ID: process.env.REACT_APP_GHL_LOCATION_CLIENT_ID ?? "",
    LOCATION_CLIENT_SECRET: process.env.REACT_APP_GHL_LOCATION_CLIENT_SECRET ?? "",
    LOCATION_SCOPE: process.env.REACT_APP_GHL_LOCATION_SCOPE ?? "workflows.readonly locations/customFields.readonly contacts.readonly",
    Location_SCOPE: process.env.REACT_APP_GHL_LOCATION_SCOPE ?? "workflows.readonly locations/customFields.readonly contacts.readonly",
    ACCOUNT_CLIENT_ID: process.env.REACT_APP_GHL_ACCOUNT_CLIENT_ID ?? "",
    ACCOUNT_CLIENT_SECRET: process.env.REACT_APP_GHL_ACCOUNT_CLIENT_SECRET ?? "",
    ACCOUNT_SCOPE: process.env.REACT_APP_GHL_ACCOUNT_SCOPE ?? "",
    REDIRECT: {
      LOCATION: redirectLocation,
      ACCOUNT: redirectAccount,
      AGENCY: redirectAgency || redirectAccount,
      Location_ASSOCIATE: redirectLocation,
      LOCAITON: redirectLocation,
    },
    LEADCONNECTOR_BASE_URL: process.env.REACT_APP_GHL_LEADCONNECTOR_BASE_URL ?? "https://services.leadconnectorhq.com",
    PREVIEW_BASE_URL: process.env.REACT_APP_GHL_PREVIEW_BASE_URL ?? "https://app.gohighlevel.com/v2/preview",
    REST_BASE_URL: process.env.REACT_APP_GHL_REST_BASE_URL ?? "https://rest.gohighlevel.com/v1",
    V2_BASE_URL: process.env.REACT_APP_GHL_V2_BASE_URL ?? "https://api.msgsndr.com",
  },
  STRIPE_CONNECT_CLIENT_ID: process.env.REACT_APP_STRIPE_CONNECT_CLIENT_ID ?? "",
  STRIPE_CONNECT_REDIRECT_URI: process.env.REACT_APP_STRIPE_CONNECT_REDIRECT_URI ?? "https://app.directorystagingsite.com/integrations/stripe",
};

export default env;
